import { Document, Page, PDFViewer, StyleSheet } from "@react-pdf/renderer";
import { Circle } from "../../components/Animation";
import { Request } from "../../hooks/Request";
import { validateArray } from "../../utils/validate";
import { MyDocClearanceForm } from "./MyDocClearanceForm";
import config from "../../config.json";

const transformData = (data, dataStateAccount) => {
  const totalAnticipos = dataStateAccount?.items
    ? dataStateAccount.items
        .filter((item) => item.type === 2)
        .reduce((sum, item) => sum + item.asset, 0)
    : 0;

  const invoice = dataStateAccount?.items
    ? dataStateAccount.items.find((item) => item.type === 8)
    : 0;
  const totalTributos =
    data?.["a-TributosYOtrosConceptosAduanerosSubDatas"] &&
    validateArray(data?.["a-TributosYOtrosConceptosAduanerosSubDatas"])
      ? data?.["a-TributosYOtrosConceptosAduanerosSubDatas"].reduce(
          (sum, e) => sum + Number(e.description2 || e.description || 0),
          0,
        )
      : 0;

  const totalErogaciones =
    data?.["b-OtrosGastosDeImportacion/ExportacionSubDatas"] &&
    validateArray(data?.["b-OtrosGastosDeImportacion/ExportacionSubDatas"])
      ? data?.["b-OtrosGastosDeImportacion/ExportacionSubDatas"].reduce(
          (sum, e) => sum + Number(e.description2 || e.description || 0),
          0,
        )
      : 0;

  const totalHonorarios =
    data?.["c-GastosDeOperacionesSubDatas"] &&
    validateArray(data?.["c-GastosDeOperacionesSubDatas"])
      ? data?.["c-GastosDeOperacionesSubDatas"].reduce(
          (sum, e) => sum + Number(e.description2 || e.description || 0),
          0,
        )
      : 0;

  const totalGeneral = totalTributos + totalErogaciones + totalHonorarios;

  console.log("🚀 ~ transformData ~ data:", data);
  return {
    numero: data.a3NúmeroDeReferencia || "",
    fecha: {
      dim: data.a2FechaDeAceptación || "",
      planilla: invoice ? invoice.date : "",
    },
    cliente: {
      nombre: data.company.razonSocial || "",
      direccion: data.company.direccion || "",
      email: data.company.email || "",
      hojaTrabajo: data.codigoDeInterno ?? "",
    },
    declaracion: {
      nroRegistro: data.a1NúmeroDeDeclaración || "-",
      regimenAduanero: data.asignarRégimenDeImportación || "-",
      aduanaDespacho: data.a4AduanaDeDespacho || "-",
      valoCif: data.f10TotalValorCifAduana || "-",
      canal: data["canal(Rojo,AmarilloOVerde)"] || "-",
    },
    descripcionMercadria: data.descripciónDeLaMercancía || "-",
    tributos:
      data?.["a-TributosYOtrosConceptosAduanerosSubDatas"] &&
      validateArray(data?.["a-TributosYOtrosConceptosAduanerosSubDatas"])
        ? data?.["a-TributosYOtrosConceptosAduanerosSubDatas"]
            .map((e) => ({
              desc: e.label,
              importe: Number(e.description2) || Number(e.description) || 0,
            }))
            .filter((h) => h.importe > 0)
        : [],
    erogaciones:
      data?.["b-OtrosGastosDeImportacion/ExportacionSubDatas"] &&
      validateArray(data?.["b-OtrosGastosDeImportacion/ExportacionSubDatas"])
        ? data?.["b-OtrosGastosDeImportacion/ExportacionSubDatas"]
            .map((e) => ({
              desc: e.label,
              importe: Number(e.description2) || Number(e.description) || 0,
            }))
            .filter((h) => h.importe > 0)
        : [],
    honorarios:
      data?.["c-GastosDeOperacionesSubDatas"] &&
      validateArray(data?.["c-GastosDeOperacionesSubDatas"])
        ? data?.["c-GastosDeOperacionesSubDatas"]
            .map((e) => ({
              desc: e.label,
              importe: Number(e.description2) || Number(e.description) || 0,
            }))
            .filter((h) => h.importe > 0)
        : [],
    totalGeneral: totalGeneral,
    tributosImportador: totalTributos,
    anticipoImportador: totalAnticipos,
    saldoContable: totalGeneral - totalAnticipos,
  };
};

const listData = [
  "a3NúmeroDeReferencia",
  "internCode",
  "codigoDeInterno",
  "nroCotizacion",
  "modalidadDeDespacho",
  "descripciónDeLaMercancía",
  "partidaArancelaria",
  "valoresNominales",
  "asignarRégimenDeImportación",
  "a1NúmeroDeDeclaración",
  "f10TotalValorCifAduana",
  "a2FechaDeAceptación",
  //
  "fechaDeCotización",
  "tipoDeDespacho",
  "proveedor",
  "piNro",
  "nroBl",
  "tipoDeCambioProforma",
  "nroDeContenedor",

  "fechaPagoDeLaDim",
  "fechaDePlanilla",
  "canal(Rojo,AmarilloOVerde)",
  "a4AduanaDeDespacho",
  "nroFacturaComercial",
  //
  "a-TributosYOtrosConceptosAduaneros",
  "b-OtrosGastosDeImportacion/Exportacion",
  "c-GastosDeOperaciones",
  // "tributosAduaneros",
  // "erogaciones",
  // "honorariosProfesionales",
];

const CustomsClearancePdf = (props) => {
  const { procedure } = props;
  const { data, loading } = Request({
    urlApi: `/Procedure/${procedure.procedureId}/dataValues?${listData
      .map((field) => `fieldnames=${field}`)
      .join("&")}`,
  });

  const { data: dataStateAccount, isLoading: isLoadingStateAccount } = Request({
    urlApi: `${config.requestURLConta}/api/StateAccount/${procedure.procedureId}`,
  });

  const styles = StyleSheet.create({
    page: {
      padding: "50px 40px",
      fontSize: 8.5,
    },
  });

  if (!loading && !isLoadingStateAccount) {
    return <Circle />;
  }
  const transformedData = transformData(data, dataStateAccount);
  return (
    <>
      <PDFViewer
        style={{
          width: 900,
          height: window.innerHeight - 100,
        }}
      >
        <Document>
          <Page size="LETTER" style={styles.page}>
            <MyDocClearanceForm data={transformedData} dataValues={data} />
          </Page>
        </Document>
      </PDFViewer>
    </>
  );
};

export default CustomsClearancePdf;
